import {IBinotelUser, IChatEmployee, IEmployee} from '@api/settings.service';

export class BinotelUsersHelper {
  public static getUserEmailById(
    binotelUsers: IBinotelUser[],
    formUsers: IBinotelUser['id'][]
  ): IBinotelUser['email'][] {
    const mappedBinotelUsers: string[] = [];
    formUsers.forEach((userId) => {
      const binotelUser = binotelUsers.find((user) => user.id === userId);
      if (binotelUser) {
        mappedBinotelUsers.push(binotelUser?.email || binotelUser?.name);
      }
    });
    return mappedBinotelUsers;
  }

  public static getUserIdByEmail(
    binotelUsers: IBinotelUser[],
    userEmails: IBinotelUser['email'][]
  ): IBinotelUser['id'][] {
    if (!userEmails?.length || !binotelUsers?.length) {
      return [];
    }
    const userMap = new Map(binotelUsers.map((user) => [user.email, user]));
    return userEmails.map((email: IBinotelUser['email']) => userMap.get(email)?.id).filter(Boolean);
  }

  public static generateMissingBinotelUserIds(users: IBinotelUser[]): IBinotelUser[] {
    if (!users?.length) {
      return [];
    }
    const readyUsers: IBinotelUser[] = [];
    users.forEach((analytic) => {
      const id = !analytic?.id ? this.crc32(analytic.email) : analytic.id;
      readyUsers.push({
        id: id,
        email: analytic.email || analytic.name,
        name: analytic.name,
      });
    });

    return readyUsers;
  }

  public static getDefaultChatEmployee(employee: IEmployee): IChatEmployee {
    return {
      status: 0,
      avatarSrc: '',
      animatedAvatarSrc: '',
      employeeId: employee?.id,
      id: 0,
      name: employee?.name,
      title: '',
      widgetId: null,
      widgetTeamId: 0,
      teamId: 0,
    };
  }

  private static crc32(str: string): number {
    const CRC32_TABLE_SIZE = 256;
    const CRC32_MASK = 0xffffffff;
    const CRC32_BYTE_MASK = 0xff;
    const CRC32_SHIFT_BITS = 8;
    const CRC32_POLYNOMIAL = 0xedb88320;

    const table = new Uint32Array(CRC32_TABLE_SIZE);
    for (let i = 0; i < CRC32_TABLE_SIZE; i++) {
      let c = i;
      for (let j = 0; j < CRC32_SHIFT_BITS; j++) {
        c = c & 1 ? CRC32_POLYNOMIAL ^ (c >>> 1) : c >>> 1;
      }
      table[i] = c;
    }

    let crc = CRC32_MASK;
    for (let i = 0; i < str.length; i++) {
      crc = (crc >>> CRC32_SHIFT_BITS) ^ table[(crc ^ str.charCodeAt(i)) & CRC32_BYTE_MASK];
    }

    return (crc ^ CRC32_MASK) >>> 0;
  }
}
